import { render, staticRenderFns } from "./ContractitemForm.vue?vue&type=template&id=04408cb4&"
import script from "./ContractitemForm.vue?vue&type=script&lang=js&"
export * from "./ContractitemForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports